var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "modal no-stacking",
      attrs: {
        id: "Auth0MigrationFeatureDisabledModal",
        "data-test-hook": "modal-title-Auth0-Migration-Feature-Disabled-Modal"
      }
    },
    [
      _c("div", { staticClass: "modal-dialog modal-dialog-centered" }, [
        _c("div", { staticClass: "modal-content" }, [
          _c(
            "div",
            { staticClass: "modal-header pb-1 pt-1 pr-0 align-items-center" },
            [
              _c(
                "h2",
                {
                  staticClass: "modal-title",
                  attrs: {
                    "data-test-hook": "modal-heading-delete-auth0-account-modal"
                  }
                },
                [
                  _c("i", {
                    staticClass: "far fa-circle-exclamation colorOrange mr-1"
                  }),
                  _vm._v(
                    " " +
                      _vm._s(_vm.$t("xAuth0MigrationInProgressModalTitle")) +
                      " "
                  )
                ]
              ),
              _c(
                "button",
                {
                  staticClass: "btn btn-icon-button btn-icon-button--gray",
                  attrs: {
                    "data-test-hook":
                      "x-close-button-delete-auth0-account-modal"
                  },
                  on: {
                    click: function($event) {
                      return _vm.closeModal()
                    }
                  }
                },
                [_c("i", { staticClass: "fas fa-times" })]
              )
            ]
          ),
          _c("div", { staticClass: "modal-body pb-0" }, [
            _c("div", { staticClass: "row", attrs: { "align-h": "around" } }, [
              _c(
                "div",
                {
                  staticClass: "col",
                  attrs: {
                    "data-test-hook":
                      "modal-body-text-delete-auth0-account-modal"
                  }
                },
                [
                  _vm._v(
                    " " +
                      _vm._s(_vm.$t("xAuth0MigrationInProgressModalBody")) +
                      " "
                  )
                ]
              )
            ])
          ]),
          _c("div", { staticClass: "modal-footer d-flex mt-2 p-0" }, [
            _c(
              "button",
              {
                staticClass: "btn btn-secondary my-3 ml-3",
                staticStyle: { flex: "1 1 0" },
                attrs: {
                  "data-test-hook": "continue-button-delete-auth0-account-modal"
                },
                on: {
                  click: function($event) {
                    return _vm.$router.push({ path: `/support` })
                  }
                }
              },
              [_vm._v(" " + _vm._s(_vm.$t("xContactSupport")) + " ")]
            ),
            _c(
              "button",
              {
                staticClass: "btn btn-primary my-3 mr-3",
                staticStyle: { flex: "1 1 0" },
                attrs: {
                  type: "button",
                  "data-test-hook": "cancel-button-delete-auth0-account-modal"
                },
                on: {
                  click: function($event) {
                    return _vm.closeModal()
                  }
                }
              },
              [_vm._v(" " + _vm._s(_vm.$t("xDone")) + " ")]
            )
          ])
        ])
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }